export default __webpack_public_path__ + "static/breadcrumbs-icons-dont-dark-98d38ab3d52b13902d994791453d7713cea9b1c83b94cfed42c138802e9df6fb.png";